module.exports = __webpack_public_path__ + "img/LoginLogoC5.06.8e90a6c0.svg";